import React from 'react';
import { ApiEndpoint } from '../components/api/ApiEndpoint';
import { customerCryptoEndpoints } from '../data/apiData';

export const CustomerCrypto: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-10 pb-8 border-b border-gray-100">
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Customer (Crypto)</h1>
        <p className="text-base text-gray-500 leading-relaxed max-w-2xl mb-5">
          Onboard customers for crypto transactions through a guided KYC flow, then generate exchange rate quotes
          and accept payments via a short-lived virtual account.
        </p>

        <div className="space-y-3">
          <h3 className="text-sm font-semibold text-gray-700">Customer flow</h3>
          <ol className="space-y-1.5">
            {[
              'Register with email — a verification email is sent automatically.',
              'Verify email via the token link.',
              'Submit NIN or BVN for identity verification.',
              'Submit selfie and liveness images to complete KYC.',
              'Get a quote for the desired amount and currency pair.',
              'Accept the quote — receive virtual account details for payment.',
              'Transfer funds to the virtual account.',
              'Poll payment status until COMPLETED.',
            ].map((step, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-gray-600">
                <span className="shrink-0 mt-0.5 h-5 w-5 rounded-full bg-[#581689]/10 text-[#581689] text-xs font-bold flex items-center justify-center">
                  {i + 1}
                </span>
                {step}
              </li>
            ))}
          </ol>
        </div>
      </div>

      <div className="space-y-6">
        {customerCryptoEndpoints.map((endpoint) => (
          <ApiEndpoint key={endpoint.id} endpoint={endpoint} />
        ))}
      </div>
    </div>
  );
};
